module.exports = __webpack_public_path__ + "static/hotblack-eventspace-d57f8d0cde9004533cedd7d25d182b24.pdf";